// extracted by mini-css-extract-plugin
export default {"wrap":"chart_wrap__V1SaN","contents":"chart_contents__qGFEZ","hscorePercent":"chart_hscorePercent__8u7V7"};